import SplitHero from "../Generic/SplitHero";
import { isLoggedIn as checkLogin } from "../../utility/UserUtils";
import { useNavigate } from "react-router-dom";

const MentorshipHero = () => {
  const navigate = useNavigate();
  const isLoggedIn = checkLogin();

  return (
    <SplitHero
      title="MENTORSHIP THAT MOVES YOU FORWARD"
      description="At WiSE, mentorship turns experience into action. We connect women with industry leaders and changemakers to build clarity, confidence, and resilience—helping them navigate the semiconductor ecosystem and grow with purpose."
      imageSrc="/assets/mentors/mentorherobg.png"
      imagePosition="left"
      buttonText={!isLoggedIn ? "Join the WiSE Mentorship Community" : null}
      onButtonClick={() => navigate("/signup")}
      cardOffsetDesktop="-4%"
    />
  );
};

export default MentorshipHero;
